import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCsrfToken } from "../../services/authService";
import { useTranslation } from "react-i18next";
import "../../styles/AdminUserDetail.css";

export default function AdminUserDetail() {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
  };

  const toggleEnabled = async () => {
    const csrf = await getCsrfToken();

    const response = await fetch(`/api/admin/users/${id}/toggle-enabled`, {
        method: "PATCH",
        credentials: "include",
        headers: {
        [csrf.headerName]: csrf.token,
        },
    });

    if (response.ok) {
        updateUser(await response.json());
    }
  };

  const toggleAdmin = async () => {
    const csrf = await getCsrfToken();

    const response = await fetch(`/api/admin/users/${id}/toggle-admin`, {
        method: "PATCH",
        credentials: "include",
        headers: {
        [csrf.headerName]: csrf.token,
        },
    });

    if (response.ok) {
        updateUser(await response.json());
    }
  };

  useEffect(() => {
    loadUser();
  }, [id]);

  const loadUser = async () => {
    const response = await fetch(`/api/admin/users/${id}`, {
      credentials: "include",
    });

    if (!response.ok) {
      setError(t("adminUserDetail.loadError"));
      return;
    }

    setUser(await response.json());
  };

  if (error) {
    return (
      <main className="admin-page">
        <section className="admin-user-detail">
          <p className="admin-error">{error}</p>
          <button onClick={() => navigate("/admin/users")}>Volver</button>
        </section>
      </main>
    );
  }

  if (!user) {
    return null;
  }

  const isAdmin = user?.roles?.includes("ROLE_ADMIN");

  return (
    <main className="admin-page">
      <section className="admin-user-detail">
        <button className="admin-back-btn" onClick={() => navigate("/admin/users")}>
          {t("adminUserDetail.back")}
        </button>

        <div className="admin-user-card">
          <div className="admin-user-header">
            <div className="admin-user-avatar">
              {user.name?.charAt(0).toUpperCase() || user.email?.charAt(0).toUpperCase()}
            </div>

            <div>
              <h1>{user.name} {user.lastname1}</h1>
              <p>{user.email}</p>
            </div>
          </div>

          <div className="admin-user-info">
            <div>
              <span>{t("adminUserDetail.id")}</span>
              <strong>{user.id}</strong>
            </div>

            <div>
              <span>{t("adminUserDetail.name")}</span>
              <strong>{user.name}</strong>
            </div>

            <div>
              <span>{t("adminUserDetail.email")}</span>
              <strong>{user.email}</strong>
            </div>

            <div>
              <span>{t("adminUserDetail.phone")}</span>
              <strong>{user.phone}</strong>
            </div>

            <div>
              <span>{t("adminUserDetail.status")}</span>
              <strong className={user.enabled ? "status-active" : "status-disabled"}>
                {user.enabled ? t("adminUserDetail.active") : t("adminUserDetail.disabled")}
              </strong>
            </div>

            <div>
              <span>{t("adminUserDetail.roles")}</span>
              <strong>
                {user.roles?.join(", ")}
              </strong>
            </div>
          </div>
          <div className="admin-user-actions">
            <button onClick={toggleEnabled}>
                {user.enabled ? t("adminUserDetail.disableUser") : t("adminUserDetail.enableUser")}
            </button>

            <button onClick={toggleAdmin}>
                {isAdmin ? t("adminUserDetail.removeAdmin") : t("adminUserDetail.makeAdmin")}
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}